import firebase from "firebase";

const config = {
  apiKey: "AIzaSyDp7-0rw1rjE0DIvq8i774kYlAqXEQCW3o",
  authDomain: "gira-the-explorer-abf47.firebaseapp.com",
  databaseURL: "https://gira-the-explorer-abf47.firebaseio.com",
  projectId: "gira-the-explorer-abf47",
  storageBucket: "gira-the-explorer-abf47.appspot.com",
  messagingSenderId: "12202616458",
  appId: "1:12202616458:web:2b6ace8dad824bc8"
};

firebase.initializeApp(config);

export const auth = firebase.auth;
export const provider = new firebase.auth.FacebookAuthProvider();

export default firebase;
